<i *ngIf="icon else elseBlock"  class="{{getClasses(icon)}} type-icon" [ngClass]="{'selected-icon': selected, 'big': big}">{{getText(icon)}}</i>
<ng-template #elseBlock><span class="empty-icon" [ngClass]="{'selected-icon': selected, 'big': big}"></span></ng-template>
